import en from 'i18n/en.json';
import da from 'i18n/da.json';
import sv from 'i18n/sv.json';
import nb from 'i18n/nb.json';
import de from 'i18n/de.json';
import is from 'i18n/is.json';
import fi from 'i18n/fi.json';
import es from 'i18n/es.json';
import el from 'i18n/el.json';
import fr from 'i18n/fr.json';
import nl from 'i18n/nl.json';
import ro from 'i18n/ro.json';

export default {
  en,
  da,
  sv,
  nb,
  de,
  is,
  fi,
  es,
  el,
  fr,
  nl,
  ro
};
